const uploadMealPopUpTranslations = {
  title: "قم بتحميل وجبتك",
  description: "قم بتحميل صورة لوجبتك",
  actionButtons: {
    submit: "إرسال",
    decline: "لا تحمل الوجبة",
  },
};

export default uploadMealPopUpTranslations;
